var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isLink
    ? _c(
        "button",
        {
          staticClass: "button",
          class: { secondary: _vm.secondary, small: _vm.small },
          attrs: { disabled: _vm.disabled },
          on: {
            click: function ($event) {
              return _vm.$emit("click")
            },
          },
        },
        [_vm._t("default")],
        2
      )
    : _c(
        "a",
        {
          staticClass: "button",
          class: { secondary: _vm.secondary, small: _vm.small },
          attrs: { href: _vm.href, target: "_blank", disabled: _vm.disabled },
        },
        [_vm._t("default")],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }